import {
  titleUI,
  currentOrPastDateUI,
  currentOrPastDateSchema,
  selectUI,
  selectSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

const VA_REGIONAL_OFFICE_CITIES = [
  'Albuquerque',
  'Anchorage',
  'Atlanta',
  'Baltimore',
  'Boise',
  'Buffalo',
  'Chicago',
  'Cleveland',
  'Columbia',
  'Denver',
  'Des Moines',
  'Detroit',
  'Honolulu',
  'Houston',
  'Indianapolis',
  'Jackson',
  'Lincoln',
  'Little Rock',
  'Los Angeles',
  'Louisville',
  'Manchester',
  'Milwaukee',
  'Montgomery',
  'Muskogee',
  'Nashville',
  'New Orleans',
  'New York',
  'Newark',
  'Oakland',
  'Philadelphia',
  'Phoenix',
  'Pittsburgh',
  'Portland',
  'Roanoke',
  'Salt Lake City',
  'San Diego',
  'San Juan',
  'Seattle',
  'St. Louis',
  'St. Paul',
  'St. Petersburg',
  'Waco',
  'Washington',
  'Wichita',
  'Winston-Salem',
];

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(
      'Past special home adaptation (SHA) grant application details',
      'Tell us about your last SHA application',
    ),
    dateLastAppliedForSha: currentOrPastDateUI({
      title: 'Date you last applied for SHA',
      errorMessages: { required: 'Enter the date you last applied for SHA' },
    }),
    vaRegionalOfficeCity: selectUI({
      title:
        'Select the city of the VA regional office connected with your past application (if you know it)',
    }),
  },
  schema: {
    type: 'object',
    properties: {
      dateLastAppliedForSha: currentOrPastDateSchema,
      vaRegionalOfficeCity: selectSchema(VA_REGIONAL_OFFICE_CITIES),
    },
    required: ['dateLastAppliedForSha'],
  },
};
